import {
  getTokenLoading,
  getTokenSuccess,
  getTokenFailure,
} from "@redux/slices/authSlice.js"
import { getToken } from "@services/auth/getToken.js"
import { useDispatch } from "react-redux"

const useAuth = () => {
  const dispatch = useDispatch()

  // const tokenFromLocalStorage = localStorage.getItem("token")

  const handleGetToken = async () => {
    try {
      // if(tokenFromLocalStorage && tokenFromLocalStorage !== null) {
      //    console.log("token from local storage:", tokenFromLocalStorage)
      //    dispatch(getTokenSuccess(tokenFromLocalStorage))
      //    return
      // }
      const userId = localStorage.getItem("userId")
      dispatch(getTokenLoading())
      const response = await getToken(userId)
      const { token } = response.data ?? {}
      dispatch(getTokenSuccess(token))
      // console.log("token from use auth:", token)
      localStorage.setItem("token", token)
    } catch (error) {
      dispatch(getTokenFailure())
      console.log(error)
    }
  }
  return { handleGetToken }
}

export default useAuth
